import styled from 'styled-components'
import { Card, Space } from 'antd'

export const ConfigCard = styled(Card)`
	margin-bottom: 1rem;
	width: 50%;

	& .ant-card-extra .ant-form-item {
		margin-bottom: 0px;
		color: red;
	}
`

export const TitleComponent = styled(Space)`
	padding: 10px;
	margin-bottom: 10px;
	border: 1px solid #d9d9d9;

	& .ant-form-item {
		margin-bottom: 0px;
	}
`
